import api from 'api/client';
import { Route, pathFromRoute } from 'utils';
import ROUTES from 'routes';

// const ROUTE = ROUTES.API.APP.DATA_SOURCES;
// const ROUTE_ADV = ROUTES.API.DATA_SOURCES;

export const STATUS = Object.freeze({
  ACTIVE: 'active',
  OFF: 'inActive',
  DRAFT: 'draft',
  ERROR: 'problem',
  PENDING: 'pending',
});

// TODO: remove targetCampaign from server, implement local
export function fetchDataSources ({ targetCampaign = true }) {
  // const query = targetCampaign ? '?target=campaign' : '';
  // const path = (new Route(ROUTE_ADV)).stringify(opts);
  return api.get(ROUTES.API.DATA_SOURCES)/*.then(resp => {
    resp.data.forEach(ds => {
      ds.stats = new Array(7).fill(0).map((_, i) => ({
        date: `2022-03-${ 10 + i }`,
        value: (Math.random()*10)|0,
      }));
    });
    return resp;
  })*/;
}

export function getDataSource (appId, id) {
  // const path = pathFromRoute(ROUTE, { id, appId });
  return api.get(ROUTES.API.DATA_SOURCES, { params: { id } });
}

export function createDataSource ({ type, appId }) {
  // const path = pathFromRoute(ROUTE, { appId });
  return api.post(ROUTES.API.DATA_SOURCES, { type }, { query: { appId } });
}

export function updateDataSource (ds) {
  // const path = `${ pathFromRoute(ROUTE, { appId, id: ds.id }) }/${ ds.type.toLowerCase() }`;
  // return api.put(path, ds);
  const route = `${ ROUTES.API.DATA_SOURCES }/${ ds.type.toLowerCase() }`;
  return api.put(route, ds, { params: { id: ds.id } });
}

// export function checkDataSourceStatus (appId, id, type, method) {
//   type = type.toLowerCase();
//   if (!['push', 'pull'].includes(method))
//     throw 'Wrong resource method';
//   const path = pathFromRoute(ROUTE + `/${type}/${method}`, { appId, id });
//   return api.get(path);
// }
